import React from 'react';

export class SearchResultCard extends React.Component {

    render() {

        var searchResult = this.props.searchResult;

        return (
                <div class="asset-item">
                    <a href={searchResult.pageUrl}>
                        <h4 class="asset-title">{searchResult.title}</h4>
                        {
                            (searchResult.hasCategories || searchResult.hasFileAssetTypes) &&
                            <div class="asset-categories">
                                {
                                    searchResult.categories?.map((category) => {
                                        return (
                                            <div class="asset-category">{category}</div>
                                        )
                                    })
                                }
                                {
                                    searchResult.fileAssetTypes?.map((fileAssetType) => {
                                        return (
                                            <div class="asset-category">{fileAssetType}</div>
                                        )
                                    })
                                }
                            </div>
                        }
                    </a>
                </div>
        );
    }

}
